import { render, staticRenderFns } from "./ehc-card.vue?vue&type=template&id=08ecb9a0&scoped=true"
import script from "./ehc-card.vue?vue&type=script&lang=js"
export * from "./ehc-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecb9a0",
  null
  
)

export default component.exports